export default function SectionApp() {
  return (
    <section id="app" className="scroll-mt-20 py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="w-full max-w-5xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 bg-background-50 rounded-2xl p-8 md:p-10">
          <div className="flex-1 text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1 bg-accent-100 text-accent-700 text-xs font-medium rounded-full mb-4 whitespace-nowrap">
              <i className="ri-smartphone-line"></i>
              随时随地
            </div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
              掌上吃瓜
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
              关注51吃瓜大赛官方公众号，第一时间获取最新爆料推送。地铁上、午休时、睡前刷一刷，不错过任何一口热乎瓜。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <div className="px-6 py-3 bg-foreground-950 text-background-50 rounded-lg flex items-center gap-2 cursor-pointer whitespace-nowrap text-sm">
                <i className="ri-wechat-line text-lg"></i>
                微信公众号
              </div>
              <div className="px-6 py-3 bg-foreground-950 text-background-50 rounded-lg flex items-center gap-2 cursor-pointer whitespace-nowrap text-sm">
                <i className="ri-weibo-line text-lg"></i>
                微博关注
              </div>
            </div>
          </div>
          <div className="flex-shrink-0">
            <div className="w-40 h-40 md:w-48 md:h-48 bg-background-200 rounded-2xl flex items-center justify-center">
              <i className="ri-qr-code-line text-5xl md:text-6xl text-foreground-400"></i>
            </div>
            <p className="text-xs text-foreground-500 text-center mt-3">扫码关注公众号</p>
          </div>
        </div>
      </div>
    </section>
  );
}